class FeaturedLinks extends HTMLElement {
    constructor() {
        super();

        this.searchPhrase = this.dataset.keyword;
        this.sectionEl = this.closest('.section--feat-links');
        this.glideComponent = this.querySelector('glide-component');
        this.glideSlides = this.glideComponent.querySelector('.glide__slides');
        this.imagePlaceholder = `/cdn/shop/t/10/assets/image-placeholder_250x.png`;

        if (!this.searchPhrase) {
            this.initGlideComponent();
        } else {
            this.initSuggest();
        }
    }

    initSuggest() {
        const query = this.searchPhrase;
        const resources = 'article'; // page,article
        const url = `${window.Shopify.routes.root}search/suggest.json?q=${query}&resources[type]=${resources}&resources[options][fields]=title,body,author`;

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                if (
                    data.resources.results &&
                    ((data.resources.results.pages && data.resources.results.pages.length > 0) ||
                        (data.resources.results.articles &&
                            data.resources.results.articles.length > 0))
                ) {
                    let mergedResults = [
                        ...(data.resources.results.pages || []),
                        ...(data.resources.results.articles || [])
                    ];

                    // Randomize the merged array
                    mergedResults = this.shuffleArray(mergedResults);

                    if (!this.glideSlides) return;
                    this.renderCustomLinks(mergedResults);
                } else {
                    console.log('No results found');
                    this.sectionEl.classList.add('hidden');
                }
            })
            .catch((error) => {
                console.error('Fetch error:', error);
            });
    }

    renderCustomLinks(results) {
        const container = this.glideSlides;

        results.forEach((result) => {
            const li = document.createElement('li');
            li.className = 'slideshow__slide glide__slide';

            li.innerHTML = `
                <div class="featured-links__link card" style="--ratio-percent: 100%;">
                    <div class="card__inner ratio" style="--ratio-percent: 66.66%;">
                        <div class="card__media">
                            <div class="media media--transparent media--hover-effect">
                                <img
                                    src="${this.appendSizeToImageUrl(result.image) || this.imagePlaceholder}"
                                    alt="${result.title}"
                                    role="presentation"
                                    height="166"
                                    width="249"
                                    loading="lazy"
                                    class="motion-reduce"
                                >
                            </div>
                        </div>
                    </div>
                    <span class="featured-links__link-title">
                        <a href="${result.url}" class="link link--text">${result.title}</a>
                    </span>
                </div>
            `;

            container.appendChild(li);
        });

        // Initialize the GlideComponent after adding all slides
        this.initGlideComponent();
    }

    initGlideComponent() {
        if (this.glideComponent && typeof GlideComponent !== 'undefined') {
            // Set data-wait-for-render to false
            this.glideComponent.setAttribute('data-wait-for-render', 'false');

            // Force the connectedCallback to run
            this.glideComponent.connectedCallback();
        } else {
            console.error('GlideComponent not found or not defined');
        }
    }

    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    appendSizeToImageUrl(url) {
        if (!url) return url;
        const [basePath, extension] = url.split(/\.(?=[^.]+$)/);
        return `${basePath}_250x.${extension}`;
    }
}

customElements.define('featured-links', FeaturedLinks);
